import { unavailableFeatureTypes } from './actionTypes'
import {
    handleUnavailableFeaturePopupErrorRequest,
    UnavailableFeaturePopupErrorPayload,
} from './types'

export const showUnavailableFeaturePopup = () => ({
    type: unavailableFeatureTypes.SHOW_UNAVAILABLE_FEATURE_POPUP,
})

export const hideUnavailableFeaturePopup = () => ({
    type: unavailableFeatureTypes.HIDE_UNAVAILABLE_FEATURE_POPUP,
})

export const handleUnavailableFeaturePopupError = (
    payload: UnavailableFeaturePopupErrorPayload,
): handleUnavailableFeaturePopupErrorRequest => ({
    type: unavailableFeatureTypes.HANDLE_UNAVAILABLE_FEATURE_POPUP_ERROR,
    payload,
})
